import { isNullOrUndefined } from "csi/utility/coreUtility";
import { Box, Checkbox } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";

export interface CheckBoxOptionProps {
	/** data-csi-automation value */
	dataCsiAutomation?: string;

	/** disable the check box */
	disabled?: boolean;

	/** indicate whether the check box section is hidden */
	hidden?: boolean;

	/** label of the check box */
	label: string;

	/** value of the option */
	optionValue: boolean;

	/** change event handler for the check box */
	onChange: (event: React.ChangeEvent<HTMLInputElement>, value: boolean) => void;

	/** bottom padding of the check box section. Default is 12px */
	paddingBottom?: number;

	/** left padding of the check box section */
	paddingLeft: number;

}

const CheckboxOption: FunctionComponent<CheckBoxOptionProps> = observer((props) => {
	const { dataCsiAutomation, disabled, hidden, label, onChange, optionValue, paddingLeft, paddingBottom } = props;
	const csiAutomation = dataCsiAutomation ? { "data-csi-automation" : dataCsiAutomation } : {};

	return (!isNullOrUndefined(optionValue) && (
		<Box 
			{...csiAutomation}
			hidden={hidden}
			pb={paddingBottom === undefined? 3 : paddingBottom}
			pl={paddingLeft}
		>
			<Checkbox
				checked={!!optionValue}
				disabled={disabled}
				labelProps={{
					res: label,
				}}
				onChange={onChange}
			/>
		</Box>
	)
	);
});

export default CheckboxOption;